<template>
    <v-dialog
        v-model="localDialog"
        width="70%"
        @update:modelValue="updateDialog"
        transition=""
        persistent
        :open-delay="0"
        :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span>Employee Advance Settlement</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="EmployeeAdvanceSettlementForm">
                    <!-- Header Section -->
                    <v-row>
                        <v-col lg="6" md="6" cols="12">
                            <v-autocomplete
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="employee_id.value.value"
                                :error-messages="employee_id.errorMessage.value"
                                clearable
                                :items="getHrmEmployeeList"
                                :item-title="item => `${item.name}`"   
                                autocomplete="off"                                               
                                item-value="id"
                                :loading="employeeLoading"
                                disabled
                            >
                                <template #label>
                                    Employee <span class="text-red-accent-4">*</span>
                                </template> 
                            </v-autocomplete>

                            <v-date-input
                                density="compact"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="settle_date.value.value"
                                :error-messages="settle_date.errorMessage.value"
                                autocomplete="off"
                                clearable
                            >
                                <template #label>
                                    Settle Date <span class="text-red-accent-4">*</span>
                                </template>
                            </v-date-input>
                        </v-col>

                        <v-col lg="6" md="6" cols="12">
                            <v-autocomplete
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="money_requisition_master_id.value.value"
                                :error-messages="money_requisition_master_id.errorMessage.value"
                                clearable
                                :items="getMoneyRequisitionList"
                                :item-title="item => `${item.code}`"   
                                autocomplete="off"                                               
                                item-value="id"
                                :loading="employeeLoading"
                                disabled
                            >
                                <template #label>
                                    Money Requisition <span class="text-red-accent-4">*</span>
                                </template> 
                            </v-autocomplete>

                            <v-textarea
                                label="Remarks (Optional)"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="remarks.value.value"
                                :error-messages="remarks.errorMessage.value"
                                clearable
                                auto-grow
                                rows="1"
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <!-- Items Section -->
                    <v-divider class="my-4"></v-divider>
                    <!-- Add Item Button -->
                    <v-row class="my-3">
                        <v-col cols="12" md="6" >   
                            <h4 class="mb-4">Settlement Items</h4>
                        </v-col>

                        <v-col cols="12" md="6" class="d-flex justify-end">
                            <v-btn
                                prepend-icon="mdi-plus"
                                variant="tonal"
                                color="primary"
                                @click="addItem"
                            >
                                Add Item
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-table density="compact" class="border">
                        <thead>
                            <tr class="bg-grey-lighten-3">
                                <th style="width: 40%;">Account Head</th>
                                <th style="width: 20%;">Amount</th>
                                <th style="width: 20%;">Description</th>
                                <th style="width: 20%; text-align: center;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="index"
                            >
                                <td>
                                    <v-autocomplete
                                    label="Account Head"
                                    density="compact"
                                    variant="outlined"
                                    bg-color="grey-lighten-4"
                                    v-model="item.account_head_id"
                                    clearable
                                    :items="getNonCashAccoutHeadList"
                                    :item-title="item => `${item.name}`"   
                                    autocomplete="off"
                                    item-value="id"
                                    class="my-2"
                                    hide-details
                                    ></v-autocomplete>

                                </td>
                                <td>
                                    <v-text-field
                                        v-model.number="item.amount"
                                        density="compact"
                                        variant="outlined"
                                        type="number"
                                        placeholder="0.00"
                                        bg-color="grey-lighten-4"
                                        hide-details
                                    ></v-text-field>
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="item.description"
                                        density="compact"
                                        variant="outlined"
                                        placeholder="Description"
                                        bg-color="grey-lighten-4"
                                        hide-details
                                    ></v-text-field>
                                </td>
                                <td style="text-align: center;">
                                    <v-btn
                                        icon
                                        size="x-small"
                                        color="error"
                                        variant="text"
                                        @click="removeItem(index)"
                                    >
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <!-- <tr v-if="items.value.length === 0">
                                <td colspan="4" class="text-center py-4 text-grey">
                                    No items added yet
                                </td>
                            </tr> -->
                        </tbody>
                    </v-table>

                    <v-checkbox
                        label="Active"
                        v-model="status.value.value"
                        :error-messages="status.errorMessage.value"
                        density="compact"
                        variant="outlined"
                        hide-details
                        single-line
                        color="primary"
                        value="1"
                        class="my-4"
                    ></v-checkbox>

                    <v-divider class="my-4"></v-divider>

                    <!-- Action Buttons -->
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                                class="bg-red"
                                variant="flat"
                                type="reset"
                                @click="closeDialog"
                            >
                                Close
                            </v-btn>
                            <v-btn 
                                class="bg-brand w-15 ms-2" 
                                variant="flat" 
                                type="submit"
                            >
                                Save
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { getCurrentInstance } from "vue";

export default {
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                employee_id: null,
                money_requisition_master_id: null,
                settle_date: '',
                items: [],
                remarks: '',
                status: 1,
            }),
        },
    },
    data() {
        return {
            items: [],
            localDialog: this.dialog,
            errorMessages: "",
            loading: false,
            isEntryMode: true,
            employeeLoading: false,
        };
    },
    computed: {
        getHrmEmployeeList() {
            return this.$store.getters.getHrmEmployeeList;
        },
        getMoneyRequisitionList() {
            return this.$store.getters.getMoneyRequisitionList;
        },
        getNonCashAccoutHeadList() {
            return this.$store.getters.getNonCashAccoutHeadList;
        },
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.employee_id.setValue(newData.employee_id || null, false);
                this.settle_date.setValue(newData.settle_date || null, false);
                this.money_requisition_master_id.setValue(newData.id || null, false);
                this.remarks.setValue(newData.remarks || "", false);
                this.status.setValue(String(newData.status) || "1", false);
                
                // Set items
                if (newData.items && newData.items.length > 0) {
                    this.items.value = newData.items;
                } else {
                    this.items.value = [];
                }
            },
        },
    },
    created() {
        if (this.$store.getters.getHrmEmployeeList.length === 0) {
            this.$store.dispatch("getHrmEmployeeList");
        }
        if (this.$store.getters.getNonCashAccoutHeadList.length === 0) {
            this.$store.dispatch("getNonCashAccoutHeadList");
        }
        
    },
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
        addItem() {
            this.items.push({
                account_head_id: null,
                amount: null,
                description: '',
            });
        },
        removeItem(index) {
            this.items.splice(index, 1);
        },
        validateItem(index) {
            const item = this.items.value[index];
            if (!item.description || item.description.trim() === '') {
                toast.warning("Please enter description");
                return false;
            }
            if (!item.amount || item.amount <= 0) {
                toast.warning("Please enter valid amount");
                return false;
            }
            return true;
        },
    },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance(); 
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                money_requisition_master_id: yup.string().required().label("Money Requisition"),
                employee_id: yup.string().required().label("Employee"),
                settle_date: yup.string().required().label("Sattlement Date"),
                remarks: yup.string().max(250).nullable().label("Remarks"),
            }),
        });

        const employee_id = useField("employee_id");
        const settle_date = useField("settle_date");
        const remarks = useField("remarks");
        const money_requisition_master_id = useField("money_requisition_master_id");
        const status = useField("status");
        const store = useStore();

        const submit = handleSubmit((values) => {
            if (proxy.items.length === 0) {
                toast.warning("Please add at least one settlement item");
                return;
            }

            // 2️⃣ Validate each item
            const hasInvalidItem = proxy.items.some((item, index) => {
                return (
                    !item.account_head_id ||
                    !item.amount ||
                    Number(item.amount) <= 0
                );
            });

            if (hasInvalidItem) {
                toast.warning("Please fill all settlement item fields correctly");
                return;
            }

            const formData = {
                ...values,
                items: proxy.items,
            };

            store
                .dispatch("saveUpdateEmployeeAdvanceSettles", formData)
                .then((response) => {
                    resetForm();
                    emit("update:dialog", false);
                    toast.success(response.data.message);
                    proxy.items = [];
                })
                .catch((error) => {
                    toast.error(error.response?.data?.message || "Error saving data");
                });
        });

        return {
            submit,
            employee_id,
            settle_date,
            money_requisition_master_id,
            status,
            remarks,
            resetForm,
        };
    },
};
</script>